// api.js

import axios from 'axios';

const API_BASE_URL = 'https://demo.prabidhienterprises.com.np/api';

// Function to make a GET request
export const getSomeData = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/alldata`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

